import type { ILocationV2 } from '@sravni/types/lib/locations';

export const DEFAULT_USER_REGION: ILocationV2 = {
  garId: 1405113,
  name: 'Москва',
  fullName: 'Город Москва',
  nameLocative: 'в Москве',
  nameGenitive: 'Москвы',
  alias: 'moskva',
  route: '6.83.',
  routeGar: '1405113',
  localityType: 'Город',
  shortLocationType: 'г',
  latitude: 55.7540471,
  longitude: 37.620405,
  priority: 2289,
  fias: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
  kladr: '7700000000000',
  okato: '45000000000',
  oktmo: '45000000',
  isoCode: 'RU-MOW',
  geoNameId: '524901',
  regionCode: '77',
  regionIsoCode: 'RU-MOW',
  regionKladr: '7700000000000',
  regionGeoNameId: '524901',
  regionOkato: '45000000000',
  regionOktmo: '45000000',
  regionRoute: '6.83.',
  regionRouteGar: '1405113',
};

export const DEFAULT_RATING_REGION: ILocationV2 = {
  name: 'Россия',
  nameLocative: 'в России',
  nameGenitive: 'России',
  route: '6.',
  alias: 'rossiya',
  latitude: 55.75367,
  longitude: 37.61989,
  garId: 1,
  fullName: 'Российская Федерация',
  routeGar: '1',
  localityType: 'страна',
  shortLocationType: 'c',
  regionRoute: '1',
  fias: '1',
};
